import styled from 'styled-components';

const Logo = styled.svg`
  border-radius: 50%;
  min-height: ${({ height }) => height};
`;

export default Logo;
